"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericContentService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
const _ = require("underscore");
class GenericContentService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.genericContentUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=';
        this.genericContentId = new Array();
    }
    getGenericContent(contentId) {
        if (_.where(this.genericContentId, { id: contentId }).length < 1) {
            return this.get(this.genericContentUrl + contentId).pipe(operators_1.map((data) => {
                this.genericContentId.push({
                    id: contentId,
                    content: data
                });
                return data;
            }));
        }
        else {
            this.genericData = _.where(this.genericContentId, { id: contentId });
            return rxjs_1.of(this.genericData[0].content);
        }
    }
}
exports.GenericContentService = GenericContentService;
//# sourceMappingURL=generic.content.service.js.map